<script setup lang="ts">
// composable
const route = useRoute()
const { handleIntegration, integrationPartnerName, error: integrationError } = useIntegrationPartner()
const { showDialog } = useIntegrationPartnerDialog()
const i18nHead = useLocaleHead()
const { ogImage, favicon, title, description } = useHeaderInformation()

// pinia stores
// load after composable to ensure nuxt instance availability in stores.
const userStore = useUserStore()

// Only attempt integration if we have the required parameters
const { userId, clientId } = route.query
const log = useLogger()

if (userId && clientId) {
  callOnce('integration-flow', async () => {
    if (!userStore.data) {
      await new Promise((resolve) => {
        const unwatch = watch(() => userStore.data, (userData) => {
          if (userData) {
            unwatch()
            resolve(userData)
          }
        }, { immediate: true })
      })
    }

    try {
      await handleIntegration()
      showDialog('success', undefined, integrationPartnerName.value)
    }
    catch (error) {
      log.warn('Integration failed', { error })
      showDialog('error', integrationError.value ?? undefined, integrationPartnerName.value)
    }
  })
}

useHead({
  title: title.value,
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs.lang,
  },
  link: [
    ...(i18nHead.value.link || []),
    { rel: 'icon', href: favicon, id: 'favicon' },
  ],
  meta: [
    ...(i18nHead.value.meta || []),
    { property: 'og:title', content: title.value },
    { property: 'description', content: description.value },
    { property: 'og:description', content: description.value },
    { property: 'og:image', content: ogImage },
    { property: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <BaseContent theme="heilandTheme">
    <slot />
    <IntegrationPartnerDialog />
  </BaseContent>
</template>

<style>
.main-container {
  padding: 24px;
  max-width: 1920px;
}
.main-wrapper {
  background-color: rgb(var(--v-theme-vm-grey-2));
  min-height: 100%;
}
</style>
